export const MAX_TEMPLATE_BUTTONS = 10;
export const MAX_BUTTON_LABEL_LENGTH = 40;
export const BUTTON_TYPE_LIMITS = Object.freeze({
  reply: 10,
  url: 2,
  phone: 1,
  payment_method: 1,
});

export const getButtonTypeCount = (buttons, type) =>
  buttons.filter(button => button.type === type).length;

export const canAddButtonType = (buttons, type, index = -1) => {
  const count = buttons.filter(
    (button, buttonIndex) => button.type === type && buttonIndex !== index
  ).length;
  return count < BUTTON_TYPE_LIMITS[type];
};

const getButtonTypeLabel = type => {
  if (type === 'url') return 'links';
  if (type === 'phone') return 'telefone';
  return 'respostas';
};

export const validateTemplateButtons = (format, buttons) => {
  const errors = [];
  if (!buttons.length) return ['Adicione ao menos um botão.'];
  if (buttons.length > MAX_TEMPLATE_BUTTONS) {
    errors.push('A Meta permite no máximo 10 botões.');
  }

  const allowedTypes =
    format === 'quick_replies'
      ? ['reply']
      : ['reply', 'url', 'phone', 'payment_method'];
  if (buttons.some(button => !allowedTypes.includes(button.type))) {
    errors.push(
      format === 'quick_replies'
        ? 'Respostas rápidas aceitam somente botões de resposta.'
        : 'Use somente resposta, link, telefone ou pedir pagamento neste formato.'
    );
  }

  Object.entries(BUTTON_TYPE_LIMITS).forEach(([type, limit]) => {
    if (getButtonTypeCount(buttons, type) > limit) {
      const label = getButtonTypeLabel(type);
      errors.push(`A Meta permite no máximo ${limit} ${label} neste modelo.`);
    }
  });

  if (
    buttons.some(
      button => (button.label || '').trim().length > MAX_BUTTON_LABEL_LENGTH
    )
  ) {
    errors.push('O texto do botão deve ter no máximo 40 caracteres.');
  }

  return errors;
};
